import { createContext } from 'react';
import type { NatFileType, AvetmissResponse } from '@duke-hq/avetmiss/NATTypes';

export type NATReportStatus = 'idle' | 'loading' | 'done' | 'error';

export interface NATReportTiming {
  startedAt: number;
  completedAt: number | null;
}

export interface NATCacheContextType {
  cacheData: (natFileId: NatFileType, data: AvetmissResponse) => void;
  updateRowData: (
    natFileId: NatFileType,
    rowIndex: number,
    updatedData: Record<string, string>,
  ) => void;
  getCachedData: (
    natFileId: NatFileType,
    fromDate: string,
    toDate: string,
  ) => AvetmissResponse | null;
  triggerGeneration: (natFileId: NatFileType, options?: { force?: boolean }) => Promise<void>;
  getStatus: (natFileId: NatFileType) => NATReportStatus;
  getTiming: (natFileId: NatFileType) => NATReportTiming | null;
}

export const NATCacheContext = createContext<NATCacheContextType | null>(null);
